export default __webpack_public_path__ + "static/media/330_private03-fr-mobile.58d0c666.png";